<template>
  <div id="ProfileDropDown" class="the-navbar__user-meta flex items-center">
    <div class="text-right leading-tight">
      <p class="font-semibold">{{ userInfo.name }}</p>
      <small class="cursor-pointer" @click="confirmLogout">{{ $t('로그아웃') }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          v-if="userInfo.photoURL"
          key="onlineImg"
          :src="userInfo.photoURL"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
          >
            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Inbox</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
          >
            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Tasks</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
          >
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Chat</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
          >
            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Wish List</span>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="confirmLogout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import * as UiUtil from "@/util/UiUtil";
import { bypassLeaveGuardToLogin } from "@/util/LeaveGuard";

export default {
  data() {
    return {};
  },

  computed: {
    userInfo() {
      return this.$store.state.auth.userInfo;
    },
  },

  created() {
    window.addEventListener("logout", this.forceLogout);
  },
  beforeDestroy() {
    window.removeEventListener("logout", this.forceLogout);
  },
  methods: {
    /**
     * 사용자가 누른 로그아웃. 한 번 더 확인한 뒤,
     * 로그인 화면으로 먼저 이동하고(작성 중이면 "저장하지 않은 데이터" 확인이 뜬다) 이동한 경우에만 로그아웃한다.
     * 이동을 취소하면 로그인 상태 그대로 작성 화면에 남는다.
     */
    async confirmLogout() {
      const ok = await UiUtil.confirmDialog("로그아웃 하시겠습니까?", { confirmBtn: "로그아웃" });
      if (!ok) return;

      const moved = await this.$router.push("/login").then(() => true, () => false);
      if (!moved) return;
      await this.$store.dispatch("USER_LOGOUT").catch(() => {});
    },
    // 세션 만료 등으로 오는 "logout" 이벤트. 묻지 않고 바로 로그아웃한다
    async forceLogout() {
      await this.$store.dispatch("USER_LOGOUT").catch(() => {}).finally(() => {
        bypassLeaveGuardToLogin();
        this.$router.push("/login").catch(() => {});
      });
    },
  },
};
</script>
